import React from "react";
import ContactOptions from "../modules/contact/components/contact.options";

export default function ContactView() {
    return (<React.Fragment>
        <h3>Contact us</h3>
        <ContactOptions />
    </React.Fragment>
    );
}